import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";

const LINKS = [
  ["About", "#about"],
  ["Ministry", "#ministry"],
  ["Warfare", "#warfare"],
  ["Associates", "#associates"],
  ["Wellness", "#wellness"],
  ["Books", "#books"],
  ["Coaching", "#coaching"],
  ["Contact", "#contact"],
];

export const scrollTo = (href) => {
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -120, duration: 1.4 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-1.5rem)] max-w-6xl">
    <motion.header data-testid="navbar"
      initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="relative rounded-full border border-white/10 bg-black/60 backdrop-blur-xl shadow-[0_10px_40px_-15px_rgba(0,0,0,0.8)]">
      <div className="px-4 sm:px-6 h-[64px] flex items-center justify-between">
        <a href="#hero" onClick={(e) => go(e, "#hero")} data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/assets/logo.jpeg" alt="Terrell Turner Ministries"
            className="h-11 w-11 rounded-full object-cover ring-1 ring-violet-400/40 shadow-[0_0_18px_rgba(139,92,246,0.35)] group-hover:shadow-[0_0_26px_rgba(245,158,11,0.45)] transition-shadow duration-300" />
        </a>
        <nav className="hidden lg:flex items-center gap-6">
          {LINKS.map(([label, href]) => (
            <a key={href} data-testid={`nav-link-${label.toLowerCase()}`} href={href} onClick={(e) => go(e, href)}
              className="relative text-xs font-semibold font-mono uppercase tracking-[0.18em] text-slate-300 hover:text-white transition-colors duration-300 after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-gradient-to-r after:from-violet-400 after:to-amber-400 hover:after:w-full after:transition-all after:duration-300">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="#invite" data-testid="nav-cta-invite" onClick={(e) => go(e, "#invite")}
            className="hidden sm:inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-gradient-to-r from-amber-400 to-violet-500 text-white text-xs font-bold uppercase tracking-[0.15em] shadow-[0_8px_25px_-8px_rgba(139,92,246,0.6)] hover:shadow-[0_8px_32px_-6px_rgba(245,158,11,0.6)] hover:brightness-110 transition-all duration-300">
            <Sparkles size={13} /> Invite Prophet Turner
          </a>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} className="lg:hidden text-white p-2" aria-label="Toggle menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden absolute top-[calc(100%+8px)] inset-x-0 rounded-3xl border border-white/10 bg-black/90 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {LINKS.map(([label, href]) => (
            <a key={href} data-testid={`nav-mobile-link-${label.toLowerCase()}`} href={href} onClick={(e) => go(e, href)}
              className="text-sm font-mono uppercase tracking-[0.2em] text-slate-300 hover:text-white transition-colors">
              {label}
            </a>
          ))}
          <a href="#invite" data-testid="nav-mobile-cta-invite" onClick={(e) => go(e, "#invite")}
            className="mt-2 inline-flex w-fit items-center gap-1.5 px-5 py-2.5 rounded-full bg-gradient-to-r from-amber-400 to-violet-500 text-white text-xs font-bold uppercase tracking-[0.15em]">
            <Sparkles size={13} /> Invite Prophet Turner
          </a>
        </nav>
      )}
    </motion.header>
    </div>
  );
}
